<template>
  <q-dialog
    :visible="isVisible"
    :title="dialogTitle"
    width="70%"
    :innerScroll="false"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
    :loading="loading"
  >
    <el-form ref="addForm" :model="addForm" label-width="100px">
      <el-row>
        <el-col :span="10">
          <el-form-item label="平台SPU码：" prop="spuCode">
            <el-input v-model.trim="addForm.spuCode" placeholder="请输入平台SPU码" size="mini" show-word-limit></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="产品型号：" prop="spuName">
            <el-input v-model.trim="addForm.spuName" placeholder="请输入产品型号" size="mini" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item label="在售店铺：" prop="checkAddFormStores">
            <el-radio-group v-model="addForm.storeIds">
              <el-radio v-for="item in stores" :label="item.id" :key="item.id" style="top: 10px">{{ item.optionValue }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-container class="table-container">
          <el-header height="auto">
            <el-button style="float: right" type="primary" size="mini" @click="openSelectSku"> 添加SKU </el-button>
          </el-header>
        </el-container>
        <el-main>
          <el-table
            v-if="addForm.skus.length > 0"
            :data="addForm.skus"
            :header-cell-style="{
              backgroundColor: '#FAFAFA',
              textAlign: 'center',
            }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%"
            :height="200"
          >
            <el-table-column prop="tskuCode" label="平台SKU码">
              <template slot-scope="scope">
                <el-input v-model.trim="scope.row.tskuCode" style="width: 150px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="storeLocation" label="店铺定位">
              <template slot-scope="scope">
                <el-input v-model.trim="scope.row.storeLocation" style="width: 150px"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="code" label="sku编码"> </el-table-column>
            <el-table-column prop="name" label="商品名称"> </el-table-column>
            <el-table-column prop="model" label="型号"> </el-table-column>
            <el-table-column prop="status" label="清仓销售状态"> </el-table-column>
            <el-table-column width="200">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="removeSku(scope.row)">移除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-row>
    </el-form>
  </q-dialog>
</template>

<script>
export default {
  name: 'AddEditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    // 1: 编辑, 2: 新增
    formType: {
      type: Number,
      default: 2
    },
    // 编辑时传入的数据
    modifyData: {
      type: Object,
      default: () => ({})
    },
    // 店铺列表
    stores: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    dialogTitle() {
      return this.formType === 2 ? 'SPU新增' : 'SPU编辑'
    }
  },
  data() {
    return {
      loading: false,
      addForm: {
        id: '',
        spuCode: null,
        spuName: '',
        storeIds: null,
        skus: []
      }
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    }
  },
  methods: {
    init() {
      if (this.formType === 1 && this.modifyData) {
        // 编辑模式
        this.addForm.spuCode = this.modifyData.code
        this.addForm.spuName = this.modifyData.name
        this.addForm.storeIds = this.modifyData.storeId
        this.addForm.skus = this.modifyData.skus || []
        this.addForm.id = this.modifyData.id
      } else {
        // 新增模式，清空表单
        this.addForm = {
          id: '',
          spuCode: null,
          spuName: '',
          storeIds: null,
          skus: []
        }
      }
    },
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      if (this.formType === 2) {
        this.add()
      } else {
        this.modifySpu()
      }
    },
    validate() {
      if (this.addForm.spuCode == null || this.addForm.spuCode === '') {
        this.$message.error('请输入SPU编码!!!!')
        return false
      }
      if (this.addForm.storeIds == null) {
        this.$message.error('请选择在售店铺!!!!')
        return false
      }
      if (this.addForm.skus.length === 0) {
        this.$message.error('请至少关联一个SKU')
        return false
      }
      return true
    },
    add() {
      if (!this.validate()) return
      
      this.loading = true
      let arr = []
      arr.push(this.addForm.storeIds)
      const from = {
        spuCode: this.addForm.spuCode,
        spuName: this.addForm.spuName,
        skus: this.addForm.skus,
        storeIds: arr
      }
      this.$q.spu
        .addSpuInfo({
          data: JSON.stringify(from)
        })
        .then((data) => {
          if (data.code === '200') {
            this.$message.success('新增成功')
            this.isVisible = false
            this.$emit('success')
          } else {
            this.$message.error(data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    modifySpu() {
      if (!this.validate()) return

      this.loading = true
      let arr = []
      arr.push(this.addForm.storeIds)
      const from = {
        spuCode: this.addForm.spuCode,
        spuName: this.addForm.spuName,
        skus: this.addForm.skus,
        id: this.addForm.id,
        storeIds: arr
      }
      this.$q.spu
        .updateSpuInfo({
          data: JSON.stringify(from)
        })
        .then((data) => {
          if (data.code === '200') {
            this.$message.success('编辑成功')
            this.isVisible = false
            this.$emit('success')
          } else {
            this.$message.error(data.message)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    openSelectSku() {
      // 通知父组件打开选择SKU弹窗
      this.$emit('open-select-sku', this.addForm.skus)
    },
    // 父组件调用，添加选中的SKU
    addSkus(skus) {
      let existingIds = this.addForm.skus.map((x) => x.id)
      for (let i = 0; i < skus.length; i++) {
        if (existingIds.indexOf(skus[i].id) === -1) {
          this.addForm.skus.push(skus[i])
        }
      }
    },
    removeSku(row) {
      let arr = []
      this.addForm.skus.forEach((x) => {
        if (x.id !== row.id) {
          arr.push(x)
        }
      })
      this.addForm.skus = arr
    }
  }
}
</script>

<style lang="stylus" scoped>
.table-container
  width 100%
</style>
